import { Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";

import VideoCarousel from "../videoCarousel";
import TextTestimonial from "../textTestimonial";
import Header from "../header";
import styles from "../home/index.module.css";
import { logo, LogoImage } from "../imagepath";
import AuthServices from "../../services/AuthServices";
const Testimonial = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);

  const handleCaptchaChange = (value) => {
    if (value) {
      setIsCaptchaVerified(true);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();

    try {
      const response = await AuthServices.sendEmail(formData);
      console.log("response", response);
      Swal.fire({
        title: "Success!",
        text: "Sucessfully Sent!",
        icon: "success",
        confirmButtonText: "OK",
      });
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      Swal.fire({
        text: "Failed to Send!",
        icon: "info",
        confirmButtonText: "OK",
      });
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header></Header>
      <div className={`text-center ${styles.teachersSection}`}>
        <h1
          className={`${styles.subTitle} m-auto`}
          style={{ maxWidth: "1000px" }}
          title="Real schools and child care centers trust AngelWatch for emergency training and compliance. Read how AngelWatch certification has protected students, saved lives, and passed inspections."
        >
          Real Success Stories — Schools and Centers Protected by AngelWatch
        </h1>
        <h2 className={`${styles.teacherSectionSubTitle}`}>
          Why Schools Choose AngelWatch
        </h2>
        <p className={`mx-auto ${styles.teacherSectionText}`}>
          When lives are on the line, preparation matters. Across the country,
          schools and child care centers trust AngelWatch to safeguard their
          students and achieve full emergency compliance. Read how our program
          has made a real difference for real institutions.
        </p>
        <div className="my-5">
          <VideoCarousel />
        </div>
      </div>
      <div className={`text-center ${styles.teachersSection}`}>
        <h2 className={`${styles.teacherSectionSubTitle}`}>
          Proven Results from Across the Country
        </h2>
        <div className="my-5">
          <TextTestimonial></TextTestimonial>
        </div>
      </div>

      <div className={styles.cta}>
        <h1 className={`text-white ${styles.cta__title}`}>
          Protect your children. Protect your staff. Stay compliant.
        </h1>
        <Link to="/getCertified">
          <button className={styles.cta__button}>
            Protect Your School — Start Today -&gt;
          </button>
        </Link>
      </div>
      <section className={styles.contact__section}>
        <h1 className={styles.contact__heading}>Contact Us</h1>
        <div className={styles.contact}>
          <div>
            <h2 className={styles.contact__title}>
              For more information contact us
            </h2>
            <div>
              <img src={LogoImage} className={styles.contact__logoImg}></img>
            </div>
            <div>
              <div className={styles.contact__list}>
                <img
                  src={require("../../assets/img/email.png")}
                  className={styles.contact__img}
                ></img>
                <p className={styles.contact__item}>Edu@AngelWatch.org</p>
              </div>
              <div className={styles.contact__list}>
                <img
                  src={require("../../assets/img/call.png")}
                  className={styles.contact__img}
                ></img>
                <p className={styles.contact__item}>+1 800-381-6794</p>
              </div>
            </div>
          </div>
          <div className={styles.contact__form}>
            <div>
              <p>Your name</p>
              <input
                type="text"
                className={styles.contact__input__info}
                placeholder="John Smith"
                name="name"
                value={formData.name}
                onChange={handleChange}
              ></input>
            </div>
            <div>
              <p>Your email</p>
              <input
                type="email"
                name="email"
                className={styles.contact__input__info}
                placeholder="abc@gmail.com"
                value={formData.email}
                onChange={handleChange}
              ></input>
            </div>
            <div className={styles.contact__message__form}>
              <p>Your message</p>
              <textarea
                type="text"
                name="message"
                className={styles.contact__message__input}
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>
            <button
              style={{ marginBottom: "20px" }}
              onClick={handleSendMessage}
              disabled={!isCaptchaVerified}
            >
              Send Message
            </button>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_SITE_KEY}
              className={`${styles.captcha}`}
              onChange={handleCaptchaChange}
            />
          </div>
        </div>
      </section>

      {/* Master Skills */}
      {/* /Master Skills */}
      <section className="d-flex flex-column">
        <div className={styles.footerTop}>
          <div className={styles.footerSection}>
            <img className={styles.footerImage} src={logo} />
            <p className={styles.footerDes}>
              All of our techniques, trainings, equipment, software, hardware,
              and instructional materials are classified and proprietary to the
              AngelWatch Foundation. We do not publicly disclose our teaching
              methodologies. This confidentiality is essential to ensure the
              ongoing safety and security of our centers, staff, and the
              children entrusted to our care. By continuously improving,
              adapting, and evolving our systems, we remain one step
              ahead—proactively closing any potential gaps and ensuring every
              base is covered.
            </p>
          </div>

          <div className={styles.footerLoginSection}>
            <p className={styles.footerTitle}>School</p>
            <Link to="/login">
              <a className={styles.footerLink1}>Login</a>
            </Link>
            <Link to="/selectregister">
              <a className={styles.footerLink1}>Register</a>
            </Link>
          </div>

          <div className={styles.footerSection}>
            <p className={styles.footerTitle}>Newsletter</p>
            <input
              className={styles.newsLetter}
              placeholder="Enter your email address"
              type="text"
            />
            <p className={styles.footerLink1}>
              Hampton Reserve Drive, Brentwood tennessee, 37027
            </p>
            <p className={styles.footerLink1}>Edu@AngelWatch.org</p>
            <p className={styles.footerLink1}>+1 800-381-6794</p>
          </div>
        </div>
        <div className={styles.footerBottom}>
          <div className={styles.footerBottomLeft}>
            <p className={styles.footerLink}>Term</p>
            <p className={styles.footerLink}>|</p>
            <p className={styles.footerLink}>Privacy</p>
          </div>
          <div className={styles.footerBottomRight}>
            <p className={styles.footerLink}>
              © 2025 AngelWatch LMS. All rights reserved.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Testimonial;
